import { PropsWithChildren } from 'react';

import { Box, Flex, forwardRef, rem, StyleProps } from '@bonusly/design-system';

interface ChipProps extends PropsWithChildren<StyleProps> {}

export const Chip = forwardRef<ChipProps, 'div'>(({ children, ...rest }, ref) => {
	return (
		<Flex alignItems="center" backgroundColor="green.100" borderRadius={rem(60)} color="green.700" display="inline-flex" h={rem(28)} ref={ref} {...rest}>
			<Box as="span" display="inline-flex" fontWeight="medium" fontSize={200} px={2}>
				{children}
			</Box>
		</Flex>
	);
});
